import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { CreateCmsToken } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type CreateCMSToken = "CREATE_CMS_TOKEN";
export const CREATE_CMS_TOKEN: CreateCMSToken = "CREATE_CMS_TOKEN";
export type CreateCMSTokenEnd = "CREATE_CMS_TOKEN_END";
export const CREATE_CMS_TOKEN_END: CreateCMSTokenEnd = "CREATE_CMS_TOKEN_END";

export interface CreateCMSTokenAction extends Action {
    type: CreateCMSToken;
    payload: {
        appId: string;
        credentials: Credentials;
    };
}

export interface CreateCMSTokenEndAction extends Action {
    type: CreateCMSTokenEnd;
    payload: {
        appId: string;
        error?: Error;
        token?: CreateCmsToken;
    };
}

export function createCMSToken(appId: string): ThunkAction<void, State, undefined, CreateCMSTokenAction> {
    return (dispatch: Dispatch<CreateCMSTokenAction>, getState) => {
        const credentials = getState().auth.credentials;

        dispatch(createCMSTokenWithCredentials(appId, credentials));
    };
}

export function createCMSTokenWithCredentials(appId: string, credentials: Credentials): CreateCMSTokenAction {
    return {
        payload: {
            appId,
            credentials
        },
        type: CREATE_CMS_TOKEN
    };
}

export function createCMSTokenEnd(appId: string, error?: Error, token?: CreateCmsToken): CreateCMSTokenEndAction {
    return {
        payload: {
            appId,
            error,
            token
        },
        type: CREATE_CMS_TOKEN_END
    };
}
